import { DatahubEntity, DatahubAction, UserEventTriggerAction, IUserEventTrigger } from 'src/interfaces/Datahub';
import { MessageEventType } from 'src/interfaces/MessageEvent';
import ApplicationService from 'src/services/ApplicationService';

const useTracking = () => {
  const trackDatahub = (entity: DatahubEntity, action: DatahubAction, data?: Record<string, unknown>) => {
    ApplicationService.datahub?.track(entity, action, data);
  };

  const trackProgress = () => {
    ApplicationService.progress?.track();
  };

  const trackUserEventTrigger = (userEventTrigger: IUserEventTrigger) => {
    ApplicationService.datahub?.track(DatahubEntity.USER_EVENT_TRIGGER, UserEventTriggerAction.MEASURE, {
      ...userEventTrigger,
    });
  };

  const trackMessageEvent = (event: MessageEventType) => {
    ApplicationService.messageEvent?.track(event);
  };

  return {
    trackProgress,
    trackDatahub,
    trackMessageEvent,
    trackUserEventTrigger,
  };
};

export default useTracking;
